const billReports = {
  description:
    'Provides an overview of trip and passenger details, including trip logistics, statuses, and key metrics for billing and auditing transport services.',
  actions: {
    export: 'Export',
  },

  table: {
    headers: {
      tripId: 'Trip Id',
      jobId: 'Booking Id',
      waitAndReturn: 'Wait And Return',
      externalId: 'External ID',
      jobStatus: 'Booking Status',
      actualPickupTime: 'Actual Pickup Time',
      actualDropTime: 'Actual Dropoff Time',
      plannedPickupTime: 'Planned Pickup Time',
      plannedDropTime: 'Planned Dropoff Time',
      canceledBy: 'Canceled By',
      assignedBy: 'Assigned By',
      routeId: 'Route Id',
      tripStatus: 'Trip Status',
      isShared: 'Shared',
      supplier: 'Supplier',
      areas: 'Zones',
      from: 'From',
      to: 'To',
      date: 'Date',
      driver: 'Driver',
      vehicle: 'Vehicle',
      profile: 'Profile',
      passenger: 'Passenger',
      email: 'Email',
      phone: 'Phone',
      attributes: 'Attributes',
      cost: 'Cost',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'New',
          onhold: 'On Hold',
          cancelled: 'Cancelled',
          routing: 'Routing',
          routed: 'Routed',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
        },
      },
    },

    filters: {
      assigned: {
        automated: 'Automated Assigned',
        manually: 'Manual Assigned',
        manuallyIntegration: 'Manually Assigned (Integration)',
        all: 'Automated & Manually Assigned',
      },
      shared: {
        onlyWithout: 'Not Shared',
        onlyWith: 'Shared',
        all: 'Shared & Not Shared',
      },

      tripStatus: 'Trip Statuses',
      jobStatus: 'Booking Statuses',
      vehicles: 'Vehicles',
      drivers: 'Drivers',
      suppliers: 'Suppliers',
      profiles: 'Profiles',
      areas: 'Zones',
      locations: 'Locations',
      airportLocations: 'Airport Locations',
      attributes: 'Attributes',
    },
  },
  tableSummary: {
    title: 'Shuttle Reports',
    headers: {
      trips: 'Trips',
      jobs: 'Bookings',
      vehicles: 'Vehicles',
      shared: 'Shared',
      autoAssigned: 'Auto Assigned',
      waitAndReturn: 'Wait And Return',
    },
  },
};

export default billReports;
